import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const TestConfigSutsInfo = () =>
  <Paragraph>
    <strong>Execution environment (EE)</strong>
    <Color variant='theme-placeholder-text'>
      The run agent where your test runs — including the software agents, resources, and settings required to run and control your tests against the SUT.
    </Color>
    <br />
    <br />
    <strong>
      <Color variant='theme-placeholder-text'>
        Any
      </Color>
    </strong>
    <Color variant='theme-placeholder-text'>
      Select any available execution environment.
    </Color>
    <br />
    <br />
    <strong>
      <Color variant='theme-placeholder-text'>
        By name
      </Color>
    </strong>
    <Color variant='theme-placeholder-text'>
      Select a specific execution environment by its name.
    </Color>
    <br />
    <br />
    <strong>
      <Color variant='theme-placeholder-text'>
        By EE tags
      </Color>
    </strong>
    <Color variant='theme-placeholder-text'>
      Select an available execution environment that matches all selected tags defined in its settings.
    </Color>
    <br />
    <br />
    <strong>
      <Color variant='theme-placeholder-text'>
        Eggplant Cloud
      </Color>
    </strong>
    <Color variant='theme-placeholder-text'>
      Run tests on Cloud SUTs with Eggplant-provisioned execution environments, including agent and EPF.
    </Color>
    <br />
    <br />
    <LinkToDocusaurus path='dai-test-configuration'>
      Learn more in the the DAI documentation
    </LinkToDocusaurus>
  </Paragraph>

export default TestConfigSutsInfo
